import React from 'react'
import { Button, NavDropdown, Nav, Dropdown } from 'react-bootstrap'
import './SessionMenuItem.css'
import OpticianProfile from "../optician/OpticianProfileContainer";
import CareUnitProfile from "../careUnit/CareUnitProfileContainer";
import {BsBoxArrowRight, BsPersonFill, BsBuilding} from "react-icons/bs";
import config from 'react-global-configuration';

const SessionMenuItem = ({loggedInUser, role, isLoggingOut, checkingSession,
                             opticianProfileDialogOpen, careUnitProfileDialogOpen,
                             onLogInClicked, onLogOutClicked,
                            onUpdateOrganizationClicked,
                            organizationName}) => (
    loggedInUser ? (
            <NavDropdown title={<span><BsPersonFill/> {loggedInUser}</span>} id="nav-dropdown" className={'SessionMenuItem'}>
                { (opticianProfileDialogOpen && <OpticianProfile/>)
                    || (careUnitProfileDialogOpen && <CareUnitProfile/>)
                    || (<span></span>)
                }

                <Dropdown.Item eventKey="Min profil" href={config.get('authServerBaseUrl') + '/realms/ogonremiss/account/?referrer=ogonremiss-webapp&referrer_uri=' + encodeURIComponent(config.get('appBaseUrl')) + '#/personal-info'}>
                    <BsPersonFill/>&nbsp;&nbsp;Min profil
                </Dropdown.Item>
                {role !== 'ADMIN' && organizationName &&
                    <Dropdown.Item eventKey="Min organisation" onClick={()=>onUpdateOrganizationClicked(role)}>
                        <BsBuilding/>&nbsp;&nbsp;Min organisation
                    </Dropdown.Item>
                }
                <Dropdown.Item divider="true" />
                <Dropdown.Item eventKey="Logga ut" onClick={()=>onLogOutClicked()}>
                    <BsBoxArrowRight/>&nbsp;&nbsp;Logga ut
                </Dropdown.Item>
            </NavDropdown>
        ) : (
            <Nav.Item onClick={()=>onLogInClicked()}><Nav.Link><Button>Logga in</Button></Nav.Link></Nav.Item>
        )
)
export default SessionMenuItem;